// Author Lin
// Date 2022-08-04 16:19:00

class SithMesInventoryLiftCheck {
        constructor({
                id = null,
                liftContents = '',
                liftLocation = '',
                liftTime = '',
                checkType = '',
                preLiftInspection = '',
                objectWeight = '',
                craneCapacity = '',
                riggingCapacity = '',
                anchorPointInspectedApproved = '',
                emergencyStopLocated = '',
                gravityCenterLocated = '',
                liftClearanceHeightSafe = '',
                liftPathKnown = '',
                landingZonePrepared = '',
                removeKnown = '',
                rigger = '',
                riggerName = '',
                riggerCommander = '',
                riggerCommanderName = '',
                attachment = '',
                remark = '',
                attachmentList = ''}
        = {}) {
            this.id = id;
            this.liftContents = liftContents;
            this.liftLocation = liftLocation;
            this.liftTime = liftTime;
            this.checkType = checkType;
            this.preLiftInspection = preLiftInspection;
            this.objectWeight = objectWeight;
            this.craneCapacity = craneCapacity;
            this.riggingCapacity = riggingCapacity;
            this.anchorPointInspectedApproved = anchorPointInspectedApproved;
            this.emergencyStopLocated = emergencyStopLocated;
            this.gravityCenterLocated = gravityCenterLocated;
            this.liftClearanceHeightSafe = liftClearanceHeightSafe;
            this.liftPathKnown = liftPathKnown;
            this.landingZonePrepared = landingZonePrepared;
            this.removeKnown = removeKnown;
            this.rigger = rigger;
            this.riggerName = riggerName;
            this.riggerCommander = riggerCommander;
            this.riggerCommanderName = riggerCommanderName;
            this.attachment = attachment;
            this.remark = remark;
            this.attachmentList = attachmentList;
        }
        }
        
        function newEntity() {
        return new SithMesInventoryLiftCheck();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'liftContents',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.liftContents',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'liftLocation',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.liftLocation',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'liftTime',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.liftTime',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'checkType',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.checkType',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '1', text: '高风险吊装检查表' },
                                    { value: '2', text: '吊装检查表' }
                    ]
                }
                },
                {
                key: 'preLiftInspection',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.preLiftInspection',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '4', text: '不满足' },
                                    { value: '3', text: '满足' }
                    ]
                }
                },
                {
                key: 'objectWeight',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.objectWeight',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'craneCapacity',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.craneCapacity',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'riggingCapacity',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.riggingCapacity',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '4', text: '不满足' },
                                    { value: '3', text: '满足' }
                    ]
                }
                },
                {
                key: 'anchorPointInspectedApproved',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.anchorPointInspectedApproved',
                sortable: true,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'emergencyStopLocated',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.emergencyStopLocated',
                sortable: true,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'gravityCenterLocated',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.gravityCenterLocated',
                sortable: true,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'liftClearanceHeightSafe',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.liftClearanceHeightSafe',
                sortable: true,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'liftPathKnown',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.liftPathKnown',
                sortable: true,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'landingZonePrepared',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.landingZonePrepared',
                sortable: true,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'removeKnown',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.removeKnown',
                sortable: true,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'rigger',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.rigger',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'riggerCommander',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.riggerCommander',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'riggerName',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.riggerName',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'riggerCommanderName',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.riggerCommanderName',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'createdByName',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.createdByName',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'attachmentList',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.attachmentList',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            liftContentsFilter : '',
            liftLocationFilter : '',
            liftTimeRteFilter : '',
            liftTimeLteFilter : '',
            checkTypeFilter : '',
            preLiftInspectionFilter : '',
            objectWeightFilter : '',
            craneCapacityFilter : '',
            riggingCapacityFilter : '',
            anchorPointInspectedApprovedFilter : '',
            emergencyStopLocatedFilter : '',
            gravityCenterLocatedFilter : '',
            liftClearanceHeightSafeFilter : '',
            liftPathKnownFilter : '',
            landingZonePreparedFilter : '',
            removeKnownFilter : '',
            riggerFilter : '',
            riggerNameFilter : '',
            riggerCommanderFilter : '',
            riggerCommanderNameFilter : '',
            createdByFilter : '',
            createdByNameFilter : '',
            attachmentFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'liftContentsFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.liftContents',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'liftLocationFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.liftLocation',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'liftTimeRteFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.liftTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'liftTimeLteFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.liftTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'checkTypeFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.checkType',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '1', text: '高风险吊装检查表' },
                        { value: '2', text: '吊装检查表' }
                    ]
                }
                },
                {
                key: 'preLiftInspectionFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.preLiftInspection',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '4', text: '不满足' },
                        { value: '3', text: '满足' }
                    ]
                }
                },
                {
                key: 'objectWeightFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.objectWeight',
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'craneCapacityFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.craneCapacity',
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'riggingCapacityFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.riggingCapacity',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '4', text: '不满足' },
                        { value: '3', text: '满足' }
                    ]
                }
                },
                {
                key: 'anchorPointInspectedApprovedFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.anchorPointInspectedApproved',
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'emergencyStopLocatedFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.emergencyStopLocated',
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'gravityCenterLocatedFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.gravityCenterLocated',
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'liftClearanceHeightSafeFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.liftClearanceHeightSafe',
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'liftPathKnownFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.liftPathKnown',
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'landingZonePreparedFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.landingZonePrepared',
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'removeKnownFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.removeKnown',
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'riggerNameFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.riggerName',
                disabled: false,
                form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"rigger":"loginName"}'
                        }
                },
                {
                key: 'riggerCommanderNameFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.riggerCommanderName',
                disabled: false,
                form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"riggerCommander":"loginName"}'
                        }
                },
                {
                key: 'createdByNameFilter',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.filter.createdByName',
                disabled: false,
                form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"createdBy":"loginName"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'liftContents',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.liftContents',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'liftLocation',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.liftLocation',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'liftTime',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.liftTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'checkType',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.checkType',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '1', text: '高风险吊装检查表' },
                        { value: '2', text: '吊装检查表' }
                    ]
                }
                },
                {
                key: 'preLiftInspection',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.preLiftInspection',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '4', text: '不满足' },
                        { value: '3', text: '满足' }
                    ]
                }
                },
                {
                key: 'objectWeight',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.objectWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'craneCapacity',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.craneCapacity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'riggingCapacity',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.riggingCapacity',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '4', text: '不满足' },
                        { value: '3', text: '满足' }
                    ]
                }
                },
                {
                key: 'anchorPointInspectedApproved',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.anchorPointInspectedApproved',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'emergencyStopLocated',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.emergencyStopLocated',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'gravityCenterLocated',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.gravityCenterLocated',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'liftClearanceHeightSafe',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.liftClearanceHeightSafe',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'liftPathKnown',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.liftPathKnown',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'landingZonePrepared',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.landingZonePrepared',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'removeKnown',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.removeKnown',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'riggerName',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.riggerName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"rigger":"loginName"}'
                        }
                },
                {
                key: 'riggerCommanderName',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.riggerCommanderName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"riggerCommander":"loginName"}'
                        }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'attachmentList',
                label: 'label.sith.inventory.sithMesInventoryLiftCheck.entity.attachment',
                sortable: false,
                disabled: false,
                form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
                    ,correspondingField: 'attachment'
                        }
                }
        ]
        
        export {SithMesInventoryLiftCheck, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        